import ModalController from "../modal_controller"

// Uniwersalny kontroler modala potwierdzenia wysyłki do KSeF.
// Obsługuje 2 tryby:
// - offline24: pojedyncza faktura z wsteczną datą (trigger z data-offline24-url)
// - bulk: zbiorcza wysyłka z listą faktur z przekroczonym terminem
export default class extends ModalController {
  static targets = [...ModalController.targets, "offlineMessage", "deadlineSection", "deadlineList"]
  static outlets = ["list--bulk"]
  static values = {
    ...ModalController.values,
    invoices: Object,
    previousBusinessDay: String,
    preservedMessage: String,
    passedMessage: String,
  }

  mode = null
  sendUrl = null

  open(event) {
    const url = event.currentTarget.dataset.offline24Url
    const deadline = event.currentTarget.dataset.offline24Deadline

    if (url) {
      this.mode = "offline24"
      this.sendUrl = url
      this.showOfflineMessage(deadline)
      this.hideDeadlineSection()
    } else {
      this.mode = "bulk"
      this.sendUrl = null
      this.hideOfflineMessage()
      this.populateDeadlineWarning()
    }

    super.open()
  }

  send() {
    if (this.mode === "offline24") {
      window.location.href = this.sendUrl
    } else if (this.hasListBulkOutlet) {
      this.submitBulkKsefSend(this.listBulkOutlet.selectedRecords)
    }
  }

  // Pełny form submit (nie fetch) — natywny redirect serwerowy pokazuje flash[:notice].
  submitBulkKsefSend(invoiceIds) {
    const form = document.getElementById("bulk_ksef_send_form")
    if (!form) {
      console.error("[bulk_ksef_send] #bulk_ksef_send_form not in DOM")
      return
    }

    form.querySelectorAll('input[name="invoice_ids[]"]').forEach(el => el.remove())

    for (const id of invoiceIds) {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "invoice_ids[]"
      input.value = String(id)
      form.appendChild(input)
    }

    form.submit()
  }

  hide(event) {
    super.hide(event)
  }

  // --- Tryb offline24: komunikat preserved/passed ---

  showOfflineMessage(deadline) {
    if (!this.hasOfflineMessageTarget) return
    this.offlineMessageTarget.textContent = deadline === "preserved"
      ? this.preservedMessageValue
      : this.passedMessageValue
    this.offlineMessageTarget.classList.remove("hidden")
  }

  hideOfflineMessage() {
    if (!this.hasOfflineMessageTarget) return
    this.offlineMessageTarget.classList.add("hidden")
  }

  // --- Tryb bulk: lista faktur z przekroczonym terminem ---

  populateDeadlineWarning() {
    if (!this.hasDeadlineSectionTarget || !this.hasDeadlineListTarget) return
    if (!this.hasListBulkOutlet) return

    const selectedIds = this.listBulkOutlet.selectedRecords
    const previousBd = this.previousBusinessDayValue
    const passedInvoices = []

    for (const id of selectedIds) {
      const data = this.invoicesValue[id]
      if (!data || !data.issue_date) continue
      if (data.issue_date < previousBd) {
        const trline = document.getElementById("trline" + id)
        const link = trline ? trline.getAttribute("data-xs-link-url-value") : `/invoices/${id}`
        const numberEl = document.getElementById("invoice_number_" + id)
        const number = numberEl ? numberEl.textContent : `#${id}`
        passedInvoices.push({ number, link })
      }
    }

    this.deadlineListTarget.replaceChildren()

    if (passedInvoices.length > 0) {
      for (const inv of passedInvoices) {
        const li = document.createElement("li")
        const a = document.createElement("a")
        a.href = inv.link
        a.textContent = inv.number
        a.target = "_blank"
        a.className = "text-blue-600 hover:text-blue-800 underline"
        li.appendChild(a)
        this.deadlineListTarget.appendChild(li)
      }
      this.deadlineSectionTarget.classList.remove("hidden")
    } else {
      this.deadlineSectionTarget.classList.add("hidden")
    }
  }

  hideDeadlineSection() {
    if (this.hasDeadlineSectionTarget) {
      this.deadlineSectionTarget.classList.add("hidden")
    }
    if (this.hasDeadlineListTarget) {
      this.deadlineListTarget.replaceChildren()
    }
  }
}
